export function hasTextSelection(editor) {
  const froalaSelection = editor?.selection?.text?.() ?? "";
  if (froalaSelection.length > 0) {
    return true;
  }

  const nativeSelection =
    typeof window !== "undefined" ? window.getSelection?.() : null;
  return !!nativeSelection && !nativeSelection.isCollapsed;
}

export function syncInlineToolbarVisibility(editor) {
  if (!editor?.toolbar) return;

  if (hasTextSelection(editor)) {
    editor.toolbar.show();
  } else {
    editor.toolbar.hide();
  }
}

export const FROALA_EDITOR_SELECTOR =
  ".fr-view, .fr-element, .fr-box, .fr-wrapper, .fr-toolbar, .fr-popup, .fr-dropdown-menu";

export function isFroalaEditorTarget(target) {
  return !!target?.closest?.(FROALA_EDITOR_SELECTOR);
}
